export default __webpack_public_path__ + "static/media/Q10_2_resized.1f479bff.jpg";